import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomModalService } from '@piqet-angular/shared';

@Component({
  selector: 'piqet-angular-new-refrigerated-truck',
  templateUrl: './new-refrigerated-truck.component.html',
  styleUrls: ['./new-refrigerated-truck.component.scss'],
})
export class NewRefrigeratedTruckComponent {
  @Output() saveNewRefrigeratedTruckEvent = new EventEmitter<any>();
  modalLabel: any;

  refrigaretedTruckData: any;
  refrigaretedTruckAddEditForm!: FormGroup;
  submitted = false;
  organizationlist: any;
  selectOrganization: any;

  constructor(private formBuilder: FormBuilder, private modal: CustomModalService) {
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['label'];
    this.refrigaretedTruckData =
      this.modal?.modalService?.config?.initialState?.['newRefrigeratedTruck'];
    const placeHolderOrganization = {
      name: 'All organization',
    };
    const newOrganizationlist = [placeHolderOrganization].concat(
      this.refrigaretedTruckData.organizationList
    );
    this.organizationlist = newOrganizationlist;
    this.organizatioListFunction();
  }

  ngOnInit(): void {
    this.refrigaretedTruckAddEditForm = this.formBuilder.group({
      refrigaredName: [this.refrigaretedTruckData.name || '', Validators.required],
      organizationName: [
        this.refrigaretedTruckData.organizationId || this.organizationlist[0],
        Validators.required,
      ],
      fuelConsumpiton: [this.refrigaretedTruckData.fuelConsumpiton || 0, Validators.required],
    });
    this.setFormData();
  }

  async organizatioListFunction() {
    await this.organizationlist?.map((item: any) => {
      if (item.id == this.refrigaretedTruckData.organizationId) {
        return (this.selectOrganization = item);
      }
    });
  }
  setFormData() {
    this.refrigaretedTruckAddEditForm.patchValue({ organizationName: this.selectOrganization });
  }
  commonInputSearch(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }
  commonInputSearchOrganization(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  onClose() {
    this.modal.close();
  }

  onSave() {
    this.submitted = true;
    if (this.refrigaretedTruckAddEditForm.invalid) {
      return;
    }
    if (this.refrigaretedTruckAddEditForm.controls['refrigaredName'].value != '' || null) {
      const myTeamsAddEditPayload = {
        refrigeratedTruckId: this.refrigaretedTruckData.refrigeratedTruckId,
        name: this.refrigaretedTruckAddEditForm.controls['refrigaredName'].value,
        fuelConsumpiton: this.refrigaretedTruckAddEditForm.controls['fuelConsumpiton'].value,
        organizationId:
          this.refrigaretedTruckAddEditForm.controls['organizationName'].value?.name ==
            'All organization' ||
          this.refrigaretedTruckAddEditForm.controls['organizationName'].value?.name == undefined
            ? null
            : this.refrigaretedTruckAddEditForm.controls['organizationName'].value?.id,
      };
      this.saveNewRefrigeratedTruckEvent.emit(myTeamsAddEditPayload);
    }
  }
}
